/**
 * created by wang lei
段前句页面
 *
 */
import React, {Component} from 'react';
import rowHeightBefore from './rowHeightBefore.png';
import SelectTool from "../components/selectTool";
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class RowHeightBeforeTool extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options:[
                {key:'5', val:'5', checked: false},
                {key:'10', val:'10', checked: false},
                {key:'15', val:'15', checked: false},
                {key:'20', val:'20', checked: false},
                {key:'25', val:'25', checked: false},
            ],
            defaultOption: '5',
        }
    }
    /**
     * 监听内容变化
     */
    listenContentChange(){
        let ulKey = this.props.editor.queryCommandValue( 'rowspacing','top');
        this.state.options.map(item=>{
            if(item.key ===  ulKey ){
                item.checked = true;
            }else{
                item.checked = false;
            }
        });
        this.setState({});
    }
    /**
     * 监听编辑器点击
     */
    listenContentClick(){
        let ulKey = this.props.editor.queryCommandValue( 'rowspacing','top');
        this.state.options.map(item=>{
            if(item.key ===  ulKey ){
                item.checked = true;
            }else{
                item.checked = false;
            }
        });
        this.selectTool.hide();
        this.setState({});
    }

    render() {
        return <div style={{display: 'inline-block'}}>
            <div className={"editor-rowHeightBefore-tool-btn"}>
                <SelectTool
                    ref={ref => this.selectTool = ref}
                    editor={this.props.editor}
                    options={this.state.options}
                    defaultOption={'5'}
                    configKey={'rowspacing'}
                    configKeyTwo={'top'}
                    imgUrl={rowHeightBefore}
                />
            </div>
            <style>{`
                .editor-rowHeightBefore-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-rowHeightBefore-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-rowHeightBefore-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style>
        </div>
    }

}